import axios from "../../../@core/axios"

// ** Get all Data
export const getAllUsers = (companyId) => async (dispatch) => {
  await axios
    .get(`/api/user/list/${companyId}`)
    .then((response) => {
      dispatch({
        type: "GET_ALL_USER",
        data: response.data
      })
    })
    .catch((err) => console.log(err))
}

// ** Get User
export const getUser = (userId) => async (dispatch) => {
  await axios
    .get(`/api/user/${userId}`)
    .then((response) => {
      dispatch({
        type: "GET_USER",
        selectedUser: response.data.user
      })
    })
    .catch((err) => console.log(err))
}

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post("/api/user/forgot/password", email)

    return response
  } catch (err) {
    console.log(err)
  }
}

export const updateUserPassword = (userId, data) => async (dispatch) => {
  try {
    const response = await axios.patch(`/api/user/${userId}/password`, data)

    return response
  } catch (err) {
    if (err.response) {
      return err.response
    } else if (err.request) {
      console.log("request", err.request)
    } else {
      console.log("message", err.message)
    }
  }
}

export const resetUserPassword = async (userId, newPassword) => {
  try {
    const response = await axios.post(`/api/user/${userId}/reset/password`, { newPassword })

    return response
  } catch (err) {
    console.log(err)
  }
}

export const inviteTeamMembers = (invitees) => async (dispatch) => {
  try {
    const response = await axios.post("/api/company/invite/team", { invitees })
    return response
  } catch (err) {
    console.log(err)
  }
}
